import {VECTOR3} from '../../index.js';

/**
 * Creates Hypercube.js directional lights.
 * @example
 * const lightdirectional = new LightDirectional(name, direction, color);
 */
class LightDirectional {

    /**
     * Stores the color.
     * @type {vector3}
     * @protected
     */
    $color;

    /**
     * Stores the direction.
     * @type {vector3}
     * @protected
     */
    $direction;

    /**
     * Stores the name.
     * @type {string}
     * @private
     */
    $name;

    /**
     * Stores the type.
     * @type {string}
     * @protected
     */
    $type = 'light.directional';

    /**
     * Gets the color.
     * @type {vector3}
     * @public
     * @readonly
     */
    get color() {

        return this.$color;
    };

    /**
     * Gets the direction.
     * @type {vector3}
     * @public
     * @readonly
     */
    get direction() {

        return this.$direction;
    };

    /**
     * Gets the name.
     * @type {string}
     * @public
     * @readonly
     */
    get name() {

        return this.$name;
    }

    /**
     * Creates a new Hypercube.js directional light.
     * @param {string} $name The name of the light.
     * @param {vector3} $direction The direction of the light.
     * @param {vector3} $color The color of the light.
     */
    constructor($name, $direction, $color) {

        this.$name = $name;
        this.$direction = VECTOR3.clone($direction);
        this.$color = VECTOR3.clone($color);
    }
}

export {

    LightDirectional
};

export default LightDirectional;
